import Lenis from 'lenis';
import { gsap, ScrollTrigger } from '../gsap/setup';
import { isTouchDevice } from '../utils/mediaQueries';

let instance;

class SmoothScroll {
  constructor() {
    if (instance) {
      return instance;
    }

    instance = this;
    this.scroll = null;
    this.refreshTimer = null;

    this.init();
    this.bindResize();
  }

  init() {
    const lenis = new Lenis({
      // Default is 0.1; higher values converge faster and feel abrupt when scroll ends.
      lerp: 0.1,
      prevent: (node) => {
        if (node.closest('.nav')) return true;

        if (isTouchDevice() && node.closest('.page-hero__trail-stage')) return true;

        return false;
      },
    });

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    this.scroll = lenis;
  }

  bindResize() {
    let resizeTimer;

    $(window).on('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.onResize(), 200);
    });
  }

  onResize() {
    if (typeof this.scroll?.resize === 'function') {
      this.scroll.resize();
    }
  }

  refresh() {
    this.onResize();
    ScrollTrigger.refresh();
    ScrollTrigger.update();
  }

  scheduleRefresh() {
    clearTimeout(this.refreshTimer);
    this.refreshTimer = setTimeout(() => this.refreshWhenIdle(), 250);
  }

  refreshWhenIdle() {
    if (this.scroll?.isScrolling) {
      this.scheduleRefresh();
      return;
    }

    this.refresh();
  }

  disableScrolling() {
    this.scroll?.stop();
  }

  enableScrolling() {
    this.scroll?.start();
  }

  getScrollTop() {
    return this.scroll?.scroll ?? window.scrollY ?? 0;
  }

  scrollToTop({ immediate = false } = {}) {
    this.scroll?.scrollTo(0, { immediate });
  }

  scrollToSection($target, centerInView = false) {
    const offset = $target.offset();

    if (!offset) {
      return;
    }

    let topOffset = offset.top;

    if (centerInView) {
      const height = $target.outerHeight() || 0;
      const windowHeight = window.innerHeight;
      topOffset = topOffset - windowHeight / 2 + height / 2;
    }

    this.scroll?.scrollTo(topOffset, {
      offset: centerInView ? 0 : -150,
      duration: 1.5,
    });
  }
}

const smoothScroll = new SmoothScroll();

export default smoothScroll;
